Backgrounds = require 'app/scripts/data/backgrounds'
React = require 'react'
_ = require 'underscore'
{ track } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

colors = []

for name, data of Backgrounds
  if data.type == 'default'
    colors = colors.concat({ key: name, name, color: data.color })

Color = ({ setBackgroundColor, name, color, boardId }) ->
  React.createElement(
    'div'
    {
      onClick: ->
        track('Board Menu', 'Change Background', name)
        setBackgroundColor name, color
        Analytics.sendUpdatedBoardFieldEvent
          field: 'background',
          value: name,
          source: 'boardMenuDrawerBackgroundColorsScreen'
          containers:
            board:
              id: boardId
          attributes:
            backgroundType: 'color'
      className: 'board-backgrounds-section-tile'
    }
    React.createElement 'div', {
      className: 'image'
      style: {
        backgroundColor: color
      }
    }
  )

module.exports = class extends React.Component
  displayName: 'ColorsView'

  render: ->
    { setBackgroundColor } = @props

    React.createElement(
      'div'
      {}
      colors.map (colorData) ->
        React.createElement Color, _.extend({ setBackgroundColor }, colorData)
    )
